import { LocationQuery } from "vue-router";

const STORAGE_KEY = "tg-bot-click";

export type TgBotClickData = {
  tgBot: string;
  tgBotButtonClick: string;
};

export class TgBotTracker {
  static capture(query: LocationQuery): void {
    const tgBot = query["tg-bot"];
    const tgBotButtonClick = query["tg-bot-button-click"];
    if (typeof tgBot !== "string" || typeof tgBotButtonClick !== "string")
      return;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ tgBot, tgBotButtonClick })
    );
  }

  static consume(): TgBotClickData | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    localStorage.removeItem(STORAGE_KEY);
    return JSON.parse(raw) as TgBotClickData;
  }
}
